module.exports = "/static/media/upload_icon.e49bb5ba.svg";